export default __webpack_public_path__ + "static/icon-map-pin-branch-34603615646d9dfb9e6ad8c42d3c24fa.png";